module.exports = __webpack_public_path__ + "static/media/sub_menu_eyewear_pink.481ad2d1.png";